import React, { useState, useEffect } from "react";
import Modal from '@mui/material/Modal';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import EditServiceModal from './edit-service-modal';
import AddServiceModal from './add-service-modal';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import CircularProgress from '@mui/material/CircularProgress';
import Chip from '@mui/material/Chip';

export default function ServicesList() {

    const [allServices, setAllServices] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [addServiceOpen, setAddServiceOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleAddServiceOpen = () => setAddServiceOpen(true);
    const handleAddServiceClose = () => setAddServiceOpen(false);
    const api_url = process.env.REACT_APP_API_URL;
    const [editedServiceId, setEditedServiceId] = useState("");
    const [serviceCategory, setServiceCategory] = useState("any");
    const [complexName, setComplexName] = useState("any");
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const formatDuration = (minutes) => {
        if (!minutes || isNaN(minutes) || minutes <= 0) {
            return '—'; // Прочерк, если время не указано
        }
        const h = Math.floor(minutes / 60);
        const m = minutes % 60;
        let result = '';
        if (h > 0) {
            result += `${h} ч `;
        }
        if (m > 0) {
            result += `${m} мин`;
        }
        return result.trim();
    };

    useEffect(() => {
        async function getAllServicesList() {
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': localStorage.getItem('token') },
            body: JSON.stringify({ service_category: serviceCategory, complex_name: complexName })
          };
          setLoading(true);
          try {
          const allServices = await (await fetch(api_url+"/api/allServices", requestOptions)).json();
          setAllServices(allServices.map(({service_id, car_category, service_category, detailing, tire_radius, service_name, min_rank, price, salary, admin_salary, price_category, service_duration, exclude_from_average_check}) => ({
            serviceId: service_id,
            carCategory: car_category,
            detailing: detailing,
            serviceCategory: service_category,
            tireRadius: tire_radius,
            serviceName: service_name,
            minRank: min_rank,
            priceCategory:price_category,
            price: price,
            salary: salary,
            admin_salary: admin_salary,
            serviceDuration: service_duration, // Добавили новое поле
            excludeFromAverageCheck: exclude_from_average_check
          })));
          } finally {
            setLoading(false);
          }
        }
        getAllServicesList();
  
    }, [open, addServiceOpen, serviceCategory, complexName]);

    function showModal(service_id){
        handleOpen();
        setEditedServiceId(service_id);
    }

    function showAddServiceModal(){
        handleAddServiceOpen();
    }

    return (
        <>
            <head>
                <title>Услуги</title>
                <meta property="og:title" content="Dashboard" key="title" />
            </head>

            <Box sx={{pt:5, pb:5}} fullWidth>
            <FormControl sx={{m:1.5, width: 300}} >
            <InputLabel id="demo-simple-select-label">Категория:</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="service-category"
                name="serviceCategory"
                value={serviceCategory}
                label="Категория"
                onChange={e => { setServiceCategory(e.target.value); setPage(0); }}
            >
            <MenuItem value={"any"}>Все</MenuItem>
            <MenuItem value={"Комплексы"}>Комплексы</MenuItem>
            <MenuItem value={"Покрытия"}>Покрытия</MenuItem>
            <MenuItem value={"Химчистка"}>Химчистка</MenuItem>
            <MenuItem value={"Кузов"}>Кузов</MenuItem>
            <MenuItem value={"Диски"}>Диски</MenuItem>
            <MenuItem value={"Двигатель"}>Двигатель</MenuItem>
            <MenuItem value={"Салон"}>Салон</MenuItem>
            <MenuItem value={"Антидождь"}>Антидождь</MenuItem>
            <MenuItem value={"Детейлинг"}>Детейлинг</MenuItem>
            <MenuItem value={"АКЦИЯ"}>АКЦИЯ</MenuItem>
            <MenuItem value={"КлючАвто"}>КлючАвто</MenuItem>
            <MenuItem value={"Арматурные работы"}>Арматурные работы</MenuItem>
            </Select>
            </FormControl>

            <FormControl sx={{m:1.5, width: 300}} >
            <InputLabel id="demo-simple-select-label">Комплекс:</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="complex_name"
                name="complexName"
                value={complexName}
                label="Комплекс"
                onChange={e => { setComplexName(e.target.value); setPage(0); }}
            >
            <MenuItem value={"any"}>Все</MenuItem>
            <MenuItem value={"ohta"}>Охта</MenuItem>
            <MenuItem value={"kudrovo"}>Кудрово</MenuItem>
            </Select>
            </FormControl>

            </Box>
            <Box sx={{ mb: 2, ml: 1.5 }}>
                <Button variant="contained" onClick={() => showAddServiceModal()}>Добавить услугу</Button>
            </Box>
            <TableContainer component={Paper} sx={{ maxHeight: 640 }}>
            <Table stickyHeader aria-label="services table">
            <TableHead>
                <TableRow>
                    <TableCell>Тип авто</TableCell>
                    <TableCell>Категория</TableCell>
                    <TableCell>Детейлинг</TableCell>
                    <TableCell>Имя</TableCell>
                    <TableCell>Длительность</TableCell>
                    <TableCell>Филиал</TableCell>
                    <TableCell align="right">Стоимость</TableCell>
                    <TableCell align="right">ЗП</TableCell>
                    <TableCell align="right">ЗП Администратора</TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {loading ? (
                    <TableRow><TableCell colSpan={10} align="center" sx={{ py: 6 }}><CircularProgress size={28} /></TableCell></TableRow>
                ) : allServices.length === 0 ? (
                    <TableRow><TableCell colSpan={10} align="center" sx={{ py: 6, color: 'text.secondary' }}>Нет услуг</TableCell></TableRow>
                ) : allServices.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(({ serviceId, carCategory, serviceCategory, detailing, serviceName, price, salary, admin_salary, priceCategory, serviceDuration, excludeFromAverageCheck }) => (
                <TableRow key={serviceId} hover>
                    <TableCell>{carCategory}</TableCell>
                    <TableCell>{serviceCategory}</TableCell>
                    <TableCell>{detailing == "yes" ? "Да" : detailing == "no" ? "Нет" : "—"}</TableCell>
                    <TableCell>
                        {serviceName}
                        {excludeFromAverageCheck && <Chip label="Не в чеке" size="small" color="warning" variant="outlined" sx={{ ml: 1 }} />}
                    </TableCell>
                    <TableCell>{formatDuration(serviceDuration)}</TableCell>
                    <TableCell>{priceCategory == "ohta_only" ? "Охта" : priceCategory == "other" ? "Кудрово" : priceCategory == "all" ? "Все филиалы" : "—"}</TableCell>
                    <TableCell align="right">{price}</TableCell>
                    <TableCell align="right">{salary}</TableCell>
                    <TableCell align="right">{admin_salary}</TableCell>
                    <TableCell>
                    <Button
                        variant="outlined"
                        onClick={() => showModal(serviceId)}>Изменить</Button>
                    </TableCell>
                </TableRow>
                ))}
            </TableBody>
            </Table>
            </TableContainer>
            {!loading && allServices.length > 0 && (
            <TablePagination
                component="div"
                count={allServices.length}
                page={page}
                onPageChange={(e, p) => setPage(p)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                rowsPerPageOptions={[10, 25, 50, 100]}
                labelRowsPerPage="Строк на странице:"
            />
            )}
            <Modal
            open={open}
            onClose={handleClose}
            >
            <EditServiceModal editedServiceId={editedServiceId} setEditWindowOpen={setOpen}/>
            </Modal>

            <Modal
            open={addServiceOpen}
            onClose={handleAddServiceClose}
            >
            <AddServiceModal setAddWindowOpen={setAddServiceOpen} />
            </Modal>
        </>
    
    )

}

